define(function (require) {
    "use strict";

	var LE = require("app");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");

    var DataSourcesLpTagController = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        DataSourcesLpTagController = Marionette.Controller.extend({

            initialize: function(){
                this.vent = LEManager.media.channel("dataSources").vent;
            },

            isConnectedToLpTag: function(){
                var connected = LE.rtDataManager.visitorCount.getWasVisited() || LE.userAssistanceController.isWebAgentReportedVisitors;
                if (connected){
                    this.updateLpTagConnectStatus(connected);
                }
                else {
                    LE.rtDataManager.visitorCount.fetch({
                        success: _.bind(this.reCheckIfConnectedToLpTag, this),
                        error: _.bind(this.onConnectedToLpTagError, this)});
                }
            },

            onConnectedToLpTagError: function(error){
                LEManager.logger.error("DataSourcesLpTagController:onConnectedToLpTagError - reporting lpTag error - " + error);
            },

            reCheckIfConnectedToLpTag: function(){
                this.updateLpTagConnectStatus(LE.rtDataManager.visitorCount.getWasVisited() || LE.userAssistanceController.isWebAgentReportedVisitors);
            },

            updateLpTagConnectStatus: function(result){
                this.vent.trigger(ManagerConfig.dataSources.mainConfig.root.TRIGGERING.SYNC_CONNECTORS_CONNECTIONS, [{id: ManagerConfig.dataSources.mainConfig.dataSourceTypes.LPTAG, isConnected: result}]);
            },
            doConnectToLptag: function(model){
                LEManager.router.navigate(LE.mediaCodes.manager.redirects.lptag);
            }
        });

    });

    return DataSourcesLpTagController;
});
